/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { CREATE_GUEST_PROFILE } from "../../../../../constants/routes";
import { useHasPermission } from "../../../../../hooks/useHasPermission";

/* Components */
import UCButton from "../../../../buttons";
import { ReactComponent as GuestProfileSvg } from '../../../../../resources/images/guest-profile.svg';

/* Styles */
import styles from "./styles.js"


const GuestNoRecords = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { checkPermission } = useHasPermission();
  const navigate = useNavigate();

  return (
    <div className={classes.noRecordsWrapper}>
      <GuestProfileSvg/>
      <div className={classes.title}>
        <FormattedMessage id="guestNoRecords.title"/>
      </div>
      <div className={classes.subtitle}>
        <FormattedMessage id="guestNoRecords.subtitle"/>
      </div>
      {
        checkPermission("F_INVITE_USER") &&
        <UCButton
          type="primary"
          className={classes.invBtn}
          onClick={() => navigate(CREATE_GUEST_PROFILE)}
          text={<FormattedMessage id="guest.createProfile"/>}
        />
      }
    </div>
  )
}

export default GuestNoRecords;
